import { useEffect, useState } from "react";
import { apixios } from "../lib/axios";
import { getPlanName } from "../lib/plan";
import { isShopify, isWeb } from "../lib/shop";

export class Plan {
  constructor (
    readonly id: string,
    readonly name: string,
    readonly status: string,
    readonly priceId?: string
  ) {}

  toString() {
    return this.name;
  }

  isActive() {
    return this.status == 'active'
  }

  isMinimum() {
    return this.name == 'ミニマムプラン' || this.name == '7日間の無料トライアル'
  }

  isNormal() {
    return this.name == 'ノーマルプラン'
  }

  isEnterprise() {
    return this.name == 'エンタープライズプラン'
  }
}

export const useSubscriptions = (authority) => {

  const [plans, setPlans] = useState<Plan[]>([])
  const [planLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if(!authority) return
    setIsLoading(true)
    if (isShopify(authority)) {
      apixios.get('/api/plans').then((res) => {
        setIsLoading(false)
        const fetchedPlans = res.data.recurring_application_charges?.map((_charge) => {
          return new Plan(_charge.id, _charge.name, _charge.status)
        })
        setPlans(fetchedPlans || [])
      }).catch((err) => {
        setIsLoading(false)
      })
    } else if (isWeb(authority)) {
      apixios.get('/api/plans/web').then((res) => {
        setIsLoading(false)
        const fetchedPlans = res.data?.map((_subscription) => {
          return new Plan(_subscription.id, getPlanName(_subscription.plan.id), _subscription.status, _subscription.plan.id)
        })
        setPlans(fetchedPlans || [])
      }).catch(() => {
        setIsLoading(false)
      })
    }
  }, [authority])

  return {plans, setPlans, planLoading}
}